import React from 'react'
import Lock from './lock.svg'
import AlertDisable from './alert-disable.svg'
import styles from './styles.css'

const ContactPrivacy: React.SFC = () => {
  return (
    <>
      <div className={styles.row}>
        <span>
          <Lock className={styles.icon} />
        </span>
        <span>
          Our platform allows you to connect with experts without them ever seeing your phone number
          or email.
        </span>
      </div>
      <div className={styles.row}>
        <span>
          <AlertDisable className={styles.icon} />
        </span>
        <span>You can turn off notifications at any time.</span>
      </div>
    </>
  )
}

export default ContactPrivacy
